
(function () {
  if (customElements.get('silo-hero-section')) return;


  const MOBILE_MAX_WIDTH = 990;
  const PRODUCT_URL = '/products/silo-vacuum-storage-system';

  function isMobileDevice() {
    return window.innerWidth < MOBILE_MAX_WIDTH;
  }


  function isCounterActive() {
    try {
      if (localStorage.getItem('discount_code')) return true;
    } catch (e) {

    }

    const bar = document.getElementById('promoBar');
    const countdown = document.getElementById('dealCountdown');
    if (bar && bar.classList.contains('has-countdown') && countdown) {

      return countdown.style.display !== 'none';
    }

    return false;
  }

  function openLeadPopup() {
    // popupRefused only silences AUTOMATIC triggers — this is an explicit click.
    // Centralized: the ACTIVE popup (ROI popup / savings wizard / A-B
    // assignment) — never the classic popup directly.
    if (typeof window.siloOpenPopup === 'function') {
      // 'badge' source: the "Trigger badge opens" setting routes this badge.
      // null = routed to "Nothing" -> report not-opened so the caller falls
      // back to the badge link navigation.
      return window.siloOpenPopup('hero_badge', 'badge') !== null;
    }

    const silo = window.siloPopupManager;
    if (!silo) return false;

    if (typeof silo.open === 'function') {
      silo.open();
      return true;
    }

    const popup = silo.popupManager;
    if (popup && typeof popup.open === 'function') {
      popup.open();
      if (typeof popup.onOpen === 'function') popup.onOpen();
      return true;
    }

    if (popup && popup.popup && popup.popup.classList) {
      popup.popup.classList.add('open', 'show');
      document.body.classList.add('popup-open');
      return true;
    }

    return false;
  }

  function playVideoWithUnlock(video, container) {
    function tryPlay() {
      video
        .play()
        .then(() => {
          container.style.background = '';
          // No opacity toggle: the <video> is already visible showing its poster (the LCP),
          // and playback frames replace the poster seamlessly.
          document.body.removeEventListener('touchstart', tryPlay, true);
          document.body.removeEventListener('click', tryPlay, true);
        })
        .catch((err) => {
          console.error('iOS: Could not autoplay hero video, waiting for interaction', err);
        });
    }
    tryPlay();

    document.body.addEventListener('touchstart', tryPlay, true);
    document.body.addEventListener('click', tryPlay, true);
  }

  class SiloHeroSection extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;


      const marker = this.closest('.shopify-section')?.querySelector(':scope > [data-experience]');
      if (marker) {
        const exp = document.documentElement.getAttribute('data-exp');
        const keys = ` ${marker.getAttribute('data-experience') || ''} `;
        if (exp !== null && !keys.includes(` ${exp} `)) return; // stay dormant (guard not set: retry allowed)
      }

      this._initialized = true;

      this._whenPosterReady(() => this.initLazyHeroVideos());
      this.initPopupTrigger();
    }


    _whenPosterReady(cb) {
      const idle = (fn) =>
        'requestIdleCallback' in window ? requestIdleCallback(fn, { timeout: 3000 }) : setTimeout(fn, 1200);
      const go = () => idle(() => requestAnimationFrame(cb));
      const container = isMobileDevice()
        ? this.querySelector('#mobile-video-hero')
        : this.querySelector('#heroDeskVideo');
      const img = (container || this).querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', go, { once: true });
        img.addEventListener('error', go, { once: true });
      } else {
        go();
      }
    }

    initLazyHeroVideos() {
      const isMobile = isMobileDevice();

      const desk = this.querySelector('#heroDeskVideo');
      const mobile = this.querySelector('#mobile-video-hero');

      // Drop the hidden viewport's block entirely so its <video> can never fetch a file/poster.
      if (isMobile && desk) desk.innerHTML = '';
      if (!isMobile && mobile) mobile.innerHTML = '';

      const container = isMobile ? mobile : desk;
      if (!container || container.dataset.loaded === '1') return;

      // The <video> is server-rendered (poster = the painted LCP) with preload='none' and NO
      // autoplay attribute, so its FILE hasn't downloaded yet. We only reach here at idle —
      // after LCP — so kick off loading + playback now. Frames replace the poster in place; the
      // video was never a separate late LCP candidate the way a JS-injected fade-in element was.
      const video = container.querySelector('video[data-hero-video]');
      if (!video) return; // image-only hero: nothing to play

      container.dataset.loaded = '1';
      video.preload = 'auto';

      if (video.readyState >= 2) {
        playVideoWithUnlock(video, container);
      } else {
        video.addEventListener('loadeddata', () => playVideoWithUnlock(video, container), { once: true });
        video.addEventListener('error', (e) => console.error('Hero video error:', e), { once: true });
        video.load();
      }
    }

    initPopupTrigger() {
      const trigger = this.querySelector('#newTanks');
      if (!trigger) return;

      trigger.addEventListener('click', (e) => {
        e.preventDefault();


        if (isCounterActive()) {
          window.location.href = PRODUCT_URL;
          return;
        }

        if (!openLeadPopup()) {
          const href = trigger.getAttribute('href');
          window.location.href = href && href !== '#' ? href : PRODUCT_URL;
        }
      });
    }
  }

  customElements.define('silo-hero-section', SiloHeroSection);


})();